import { handleRest } from '../../h2Api'
import * as assignmentActions from '../../actions/admin/adminLessonActions'
import { UNASSIGN_LESSON_FROM } from '../../actions/admin/adminLessonActions'

const initialState = {
  data: handleRest(null)
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case assignmentActions.PLAN_USER_ASSIGNMENT_LIST:
      return {
        ...state,
        data: handleRest(action)
      }
    case UNASSIGN_LESSON_FROM:
      const filteredAssignments = ((state.data.result || {}).assignments || []).filter(
        d => d.user.id !== action.userId
      )

      return {
        ...state,
        data: {
          ...state.data,
          result: {
            ...state.data.result,
            assignments: filteredAssignments
          }
        }
      }
    default:
      return state
  }
}

export default reducers
